import { getCardPaymentsForIntegration } from 'reducers/Payments';
import { deletePayment, markForProcessing } from 'actions/Payments';
import { openTerminalIntegration } from 'actions/integrations/terminal';
import { CardPaymentHooks } from 'paymentIntegrations/types';

import processPayments from './handlers/processPayments';

export const title = 'Junction Transaction';

export const initPayments = (params: CardPaymentHooks) => async (
  dispatch,
  getState,
) => {
  const { enableButtons, resolvePayments, rejectPayments } = params;
  const cardPayments = getCardPaymentsForIntegration('junction')(getState());

  enableButtons([]);

  dispatch(processPayments({ ...params, cardPayments }))
    .then(data => {
      const shouldVoid = getCardPaymentsForIntegration('junction')(
        getState(),
      ).every(p => p.paid && p.shouldProcess);
      if (data.errors) {
        enableButtons(['close']);
      } else if (shouldVoid) {
        rejectPayments();
      } else {
        resolvePayments();
      }
    })
    .catch(err =>
      console.error('Failed to process payments with Junction', err),
    );
};

export const voidPayments = () => async (dispatch, getState) => {
  getCardPaymentsForIntegration('junction')(getState()).forEach(
    ({ key, paid }) => {
      if (paid) {
        dispatch(markForProcessing({ key }));
      } else {
        dispatch(deletePayment({ key }));
      }
    },
  );

  if (getCardPaymentsForIntegration('junction')(getState())?.length) {
    await dispatch(openTerminalIntegration());
  }
};

function close(params: CardPaymentHooks) {
  return async (_dispatch, _getState) => {
    return params.rejectPayments();
  };
}

type Button = {
  text: string;
  name: 'forceCancel' | 'forceSuccess' | 'close';
  actionOnClick?: (
    params: CardPaymentHooks,
  ) => (dispatch: any, getState: any) => Promise<void>;
  variant: string;
};

const forceCancel: Button = {
  text: '',
  name: 'forceCancel',
  variant: 'plain', // HACK: Non existing variant has no bg color
};

const forceSuccess: Button = {
  text: '',
  name: 'forceSuccess',
  variant: 'plain', // HACK: Non existing variant has no bg color
};

export const functions: Button[] = [
  forceCancel,
  {
    actionOnClick: close,
    text: 'Close',
    name: 'close',
    variant: 'warning',
  },
  forceSuccess,
];
